module.exports = __webpack_public_path__ + "static/img/diamond-purple.e15bc75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/diamond-purple.png
// module id = lhhR
// module chunks = 1